// extracted by mini-css-extract-plugin
export default {"loginForm":"LoginForm_loginForm__a4w3E","loginFormForgot":"LoginForm_loginFormForgot__syNS9","loginFormButton":"LoginForm_loginFormButton__yIdCU"};